import {useOutletContext} from 'react-router-dom';

import {useGetUserBans} from '@entities/user';
import {UserBansTable} from '@widgets/user';
import {UserAccountOutletContext} from './types';

export const BansTab = () => {
  const {user} = useOutletContext<UserAccountOutletContext>();
  const {data, isPending, error} = useGetUserBans(user.id);
  return (
    <UserBansTable
      data={data ?? []}
      error={error}
      state={{isLoading: isPending}}
    />
  );
};
